import React, { useState } from "react";
import HeroSection from "../components/HeroSection";
import icons from "../constants/icons.ts";
import { contactInfo, heroSections, socialLinks } from "../constants/data.ts";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log("Form submitted:", formData);
    setSubmitted(true);
    setFormData({ name: "", email: "", phone: "", subject: "", message: "" });

    // Reset submitted message after 3 seconds
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <main className="bg-background">
      {/* Hero Section */}
      <HeroSection {...heroSections.contact} />

      {/* Contact Information & Form */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="heading-main mb-8">Get In Touch</h2>

              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <a
                    key={index}
                    href={info.href}
                    className="flex gap-4 hover:text-primary transition-colors"
                  >
                    <i
                      className={`${info.icon} text-2xl text-primary flex-shrink-0 mt-1`}
                    ></i>
                    <div>
                      <p className="font-rubik font-medium text-secondary">
                        <strong>{info.label}</strong>
                      </p>
                      <p className="text-body text-sm">{info.value}</p>
                    </div>
                  </a>
                ))}
              </div>

              {/* Social Links */}
              <div className="mt-8">
                <h3 className="heading mb-4">Follow Us</h3>
                <div className="flex gap-4">
                  {socialLinks.map((social) => (
                    <a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center hover:bg-opacity-90 transition-all"
                      aria-label={social.label}
                    >
                      <i className={social.compactIcon}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2">
              <div className="card">
                <h2 className="heading-main mb-6">Send us a Message</h2>

                {submitted && (
                  <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-card mb-6">
                    <p className="font-rubik">
                      <i className={`${icons.actions.checkCircle} mr-2`}></i>
                      Thank you! We'll get back to you soon.
                    </p>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        htmlFor="name"
                        className="block font-rubik font-medium text-secondary mb-2"
                      >
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-card font-rubik focus:outline-none focus:border-primary transition-colors"
                        placeholder="Your Name"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="email"
                        className="block font-rubik font-medium text-secondary mb-2"
                      >
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-card font-rubik focus:outline-none focus:border-primary transition-colors"
                        placeholder="your@gmail.com"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        htmlFor="phone"
                        className="block font-rubik font-medium text-secondary mb-2"
                      >
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-card font-rubik focus:outline-none focus:border-primary transition-colors"
                        placeholder="+91 xxxx-xxx-xxx"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="subject"
                        className="block font-rubik font-medium text-secondary mb-2"
                      >
                        Subject *
                      </label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-card font-rubik focus:outline-none focus:border-primary transition-colors"
                        placeholder="Services Required"
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="message"
                      className="block font-rubik font-medium text-secondary mb-2"
                    >
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      className="w-full px-4 py-2 border border-gray-300 rounded-card font-rubik focus:outline-none focus:border-primary transition-colors resize-none"
                      placeholder="Tell us about Required Services"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="btn-primary w-full flex items-center justify-center gap-2"
                  >
                    <i className={icons.actions.paperPlane}></i>
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
